import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { SnackbarManager } from './managers/snackbar-manager';
//import { IDadosSenha } from './interfaces/ialterar-senha';
import { ClienteSingletonService } from 'src/app/singletons/cliente-singleton.service';
import { ConfigService } from './services/config.service';
import { MessageDialogCutomizadoComponent } from './components/genericos/message-dialog-cutomizado/message-dialog-cutomizado.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class JwtService {

	constructor(
		private configService: ConfigService,
		private httpClient: HttpClient,
		private router: Router,		
		private snackBarManager: SnackbarManager,
		private clienteSingletonService: ClienteSingletonService,
		private dialog: MatDialog
	) { }


	login(user: string, password: string) {
		return this.httpClient.post(
			this.configService.getEndereco() + '/login',
			{
				username: user,
				password: password,
			},
			{ headers: new HttpHeaders({ 'authToken': "" })}
		)
	}


	logout() {
		const urlRedirect = this.router.url;
		const token = localStorage.getItem('access_token');

		if(!localStorage.getItem('urlRedirect')){
			localStorage.clear();
			this.router.navigate(['/login']);
		}

		if(urlRedirect !== "/home" && urlRedirect !== "/login" && !token){
			localStorage.setItem('urlRedirect', urlRedirect);
		}
	}


	public static loggedIn(): boolean{
		return localStorage.getItem('access_token') !==  null;
	}

	// public checkLogin () {
	// 	if (!JwtService.loggedIn()) {
	// 		this.router.navigate(['/login']);
	// 	}
	// }

	// public InicioLogin(){
	// 	if(localStorage.getItem('access_token') == null){
	// 		this.router.navigate(['/login']);
	// 	}
	// }

	public validarAcessToken(httpErrorResponse: HttpErrorResponse = null){
		const segundosExpires: number = Number.parseInt(localStorage.getItem("expires_at_seconds"));
		const accesToken = localStorage.getItem("access_token");
		const dataAtual = new Date;
		const dataExpiracao = new Date()
		dataExpiracao.setSeconds(segundosExpires);

		if ((dataExpiracao < dataAtual) || (accesToken == 'undefined') || (accesToken == null) || 
		((httpErrorResponse !== null) && ((httpErrorResponse.status === 401) || (httpErrorResponse.status === 403)) 
		&& (!httpErrorResponse.ok))){
			this.logout();
		}
	}

	// public alterarSenha(dadosSenha: IDadosSenha): Observable<any>{
	// 	this.validarAcessToken();

    //     return this.httpClient.put<any>(
    //         `${this.configService.getEndereco()}/login/alterar-senha`,
    //         dadosSenha,
    //         { headers: new HttpHeaders({authToken: localStorage.getItem('access_token')})}
    //     );
	// }

	temAcesso(){
        return this.httpClient.get(
                this.configService.getEndereco() + '/acesso/hasAcesso?modulo=PORTAL',
                {
                    headers: this.configService.getHeaders(),
                }
            )
    }

	dialogMensagemSessaoExpirada(){
		const dialogRef = this.dialog.open(MessageDialogCutomizadoComponent, {
			width: '300px',
			disableClose: true,
			data: { message: "Sua sessão expirou. Efetue o login novamente." }
		});
	
		dialogRef.afterClosed().subscribe(() => {
			this.logout();
		});
	}
}


// private baseUrl = '/ws/user/login';
	// login(cnpj: string, pass: string): Observable<any> {
	// 	const headers = new HttpHeaders({
	// 		'Content-Type': 'application/json',
	// 		// Outros cabeçalhos, se necessário
	// 	});

	// 	return this.httpClient.get(this.baseUrl, { headers });
	// }	
